package net.zagart.ai.core.feature.story

sealed class StoryNode {
    data class Narrative(
        val text: String,
        val choices: List<StoryChoice>
    ) : StoryNode()

    data class Ending(
        val text: String,
        val epilogue: String? = null
    ) : StoryNode()
}
